import type { ReadonlyDeep } from 'type-fest';
import type { DataItem as BookedAirRoadTableDataItem } from '@/components/tables/BookedAirRoadTable.vue';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { arJobStatuses } from '@/utils/PortalConstants';
import { getStrCell } from '@/utils/file';
import * as oneTrackingJobHelpers from '@/helpers/trackingJob/oneTrackingJob';

export function getTableItem(
  bookedArJob: ReadonlyDeep<
    NonNullable<openapi.AirroadList2ContentOpenapi['results']>[0]
  >,
): BookedAirRoadTableDataItem {
  const { jobId, jobDate } =
    oneTrackingJobHelpers.getJobIdAndJobDate(bookedArJob);

  return {
    id: bookedArJob.id,
    jobId,
    jobDate,
    customerCode: getStrCell(bookedArJob.customer),
    status: getStrCell(
      arJobStatuses.find((item) => item.value === bookedArJob.status)?.text,
    ),
    connote: getStrCell(bookedArJob.connote),
    reference1: getStrCell(bookedArJob.reference_1),
    reference2: getStrCell(bookedArJob.reference_2),
    labels: !!bookedArJob.labels,
    fold: {
      bookedArJob,
    },
  };
}

export function getTableData(
  airRoadBookedJobsData:
    | ReadonlyDeep<openapi.AirroadList2ContentOpenapi>
    | undefined,
): BookedAirRoadTableDataItem[] {
  const _bookedAirRoadTableData: BookedAirRoadTableDataItem[] = [];
  if (!airRoadBookedJobsData?.results?.length) {
    return _bookedAirRoadTableData;
  }
  airRoadBookedJobsData.results.forEach(function (bookedArJob) {
    _bookedAirRoadTableData.push(getTableItem(bookedArJob));
  });
  return _bookedAirRoadTableData;
}
